export const USER_SET_UP_EMAIL_AND_PASSWORD_REQUEST = 'USER_SET_UP_EMAIL_AND_PASSWORD_REQUEST';
export const USER_SET_UP_EMAIL_AND_PASSWORD_SUCCESS = 'USER_SET_UP_EMAIL_AND_PASSWORD_SUCCESS';
export const USER_SET_UP_EMAIL_AND_PASSWORD_FAIL = 'USER_SET_UP_EMAIL_AND_PASSWORD_FAIL';

export const ADD_SDM_TO_USER_BALANCE = 'ADD_SDM_TO_USER_BALANCE';
export const SUBTRACT_SDM_TO_USER_BALANCE = 'SUBTRACT_SDM_TO_USER_BALANCE';
export const SET_SDM_TO_USER_BALANCE = 'SET_SDM_TO_USER_BALANCE';
